import * as z from "zod/v4";

/**
 * Schema for variant/control group revenue statistics
 */
const groupRevenueStatsSchema_ = z.object({
  /** Revenue per customer in the group's currency */
  revenuePerCustomer: z.number(),
  /** Total attributed revenue for this group */
  totalRevenue: z.number(),
  /** Revenue per 1,000 customers (totalRevenue / customerCount * 1000) */
  revenuePer1kCustomers: z.number(),
  /** Total customers in this group */
  customerCount: z.number(),
});
export const groupRevenueStatsSchema: z.ZodType<GroupRevenueStats> =
  groupRevenueStatsSchema_;
export interface GroupRevenueStats
  extends z.infer<typeof groupRevenueStatsSchema_> {}

export const getMarketingAgentRevenueStats = {
  name: "getMarketingAgentRevenueStats" as const,
  input: z.object({
    /** Max number of days to look back */
    days: z.number(),
  }),
  output: z
    .object({
      /** Marketing agent (variant) group stats */
      variant: groupRevenueStatsSchema,
      /** Legacy automations (control) group stats */
      control: groupRevenueStatsSchema,
    })
    .nullable(),
};
